<h2 mat-dialog-title>Send To Bruce (Ondemand)</h2>
<mat-dialog-content>
  <div><em>{{data.file.filename}}</em></div>
	<mat-form-field class="example-full-width">
		<mat-label>Save as</mat-label>
		<input matInput [(ngModel)]="data.rename">
	</mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close="abort">Cancel</button>
  <button mat-button [mat-dialog-close]="data.rename" cdkFocusInitial>Send</button>
</mat-dialog-actions>